(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["at-main-product"]) return;
  try {
    
  (function () {
    'use strict';
    if (window.ATpdp) return;
    window.ATpdp = true;

    function money(cents) {
      if (window.AT && AT.formatMoney) return AT.formatMoney(cents);
      return '$' + String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function msiOf(cents) { return Math.round(cents / 1200) * 100; }
    function pickText(t) {
      t = t || '';
      if (t.indexOf('||') < 0) return t;
      var parts = t.split('||');
      var desk = window.matchMedia && window.matchMedia('(min-width: 990px)').matches;
      return (desk ? parts[0] : (parts[1] || parts[0])).trim();
    }
    window.ATpdpPick = pickText;
    function each(list, fn) { Array.prototype.forEach.call(list, fn); }
    function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function formOf(root) { return root.querySelector('form[data-at-product-form]'); }

    /* ---------- total, WhatsApp y paquetes por cantidad ---------- */
    function unitOf(root) {
      var form = formOf(root);
      var base = form ? parseInt(form.getAttribute('data-price') || '0', 10) : 0;
      if (!base) {
        var json = root.querySelector('script[data-at-product-json]');
        var id = form && form.querySelector('input[name="id"]');
        try {
          var p = JSON.parse(json.textContent);
          var v = p.variants.filter(function (x) { return id && String(x.id) === String(id.value); })[0] || p.variants[0];
          base = v.price;
        } catch (err) { base = 0; }
      }
      return base;
    }
    function qtyOf(root) {
      var q = root.querySelector('form[data-at-product-form] input[name="quantity"]');
      return Math.max(1, parseInt(q && q.value, 10) || 1);
    }
    function isFleet(root) {
      var o = root.querySelector('[data-at-pdp-qp] .at-pdp-qp__o.is-on');
      return !!(o && o.hasAttribute('data-at-qp-fleet'));
    }
    function update(root) {
      if (!root || !root.querySelector) return;
      var unit = unitOf(root);
      var qty = qtyOf(root);
      var fleet = isFleet(root);
      var extra = 0;
      var withWarranty = false;
      var withNames = [];
      each(root.querySelectorAll('[data-at-pdp-warranty]'), function (w) { if (w.checked) { extra += parseInt(w.getAttribute('data-price') || '0', 10); withWarranty = true; withNames.push('garantía extendida'); } });
      var addonsTotal = 0;
      each(root.querySelectorAll('form[data-at-product-form] input[data-at-addon-extra]'), function (a) { if (a.checked) { addonsTotal += parseInt(a.getAttribute('data-price') || '0', 10); withNames.push(a.getAttribute('data-name') || ''); } });
      var total = (unit + extra) * qty + addonsTotal;
      each(root.querySelectorAll('[data-at-pdp-total]'), function (t) {
        each(t.querySelectorAll('[data-at-pdp-tot-v],[data-at-pdp-tot-lv]'), function (b) { b.textContent = money(total); });
        each(t.querySelectorAll('[data-at-pdp-tot-x]'), function (x) { x.hidden = !withNames.length; x.textContent = withNames.length ? ' con ' + withNames.join(' y ') : ''; });
        each(t.querySelectorAll('[data-at-pdp-tot-retail]'), function (x) { x.hidden = fleet; });
        each(t.querySelectorAll('[data-at-pdp-tot-fleet]'), function (x) { x.hidden = !fleet; });
        each(t.querySelectorAll('[data-at-pdp-tot-msi]'), function (x) {
          x.hidden = fleet || total < 2000000;
          var m = x.querySelector('[data-at-pdp-tot-m]');
          if (m) m.textContent = money(msiOf(total));
        });
        each(t.querySelectorAll('[data-at-pdp-tot-ship]'), function (x) { x.hidden = fleet; x.textContent = total >= 200000 ? 'Envío gratis' : ''; });
      });
      // paquetes por cantidad: precios de cada opción con la variante actual
      each(root.querySelectorAll('[data-at-pdp-qp] [data-at-qp-qty]'), function (o) {
        var q = parseInt(o.getAttribute('data-at-qp-qty'), 10) || 1;
        var b = o.querySelector('[data-at-qp-total]');
        if (b) b.textContent = money(unit * q);
        var s = o.querySelector('[data-at-qp-msi]');
        if (s) { s.hidden = unit * q < 2000000; s.textContent = '12 MSI de ' + money(msiOf(unit * q)); }
      });
      // WhatsApp con producto, versión, cantidad y garantía
      var form = formOf(root);
      var name = (form && form.getAttribute('data-at-pdp-name')) || '';
      var sum = root.querySelector('[data-at-cx-sum-v]');
      var ver = sum ? sum.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!ver) {
        try {
          var pj = JSON.parse(root.querySelector('script[data-at-product-json]').textContent);
          var idv = form && form.querySelector('input[name="id"]');
          var vv = pj.variants.filter(function (x) { return idv && String(x.id) === String(idv.value); })[0];
          if (vv && vv.title && vv.title !== 'Default Title') ver = vv.title;
        } catch (err) { /* sin versión */ }
      }
      var pack = root.getAttribute('data-at-pdp-pack');
      if (pack) name = pack;
      var msg = fleet
        ? 'Hola, quiero cotizar ' + name + (ver ? ' (' + ver + ')' : '') + ' para un operador o flota: 3 piezas o más. ¿Me mandan cotización con factura?'
        : 'Hola, quiero comprar ' + (qty > 1 ? qty + ' × ' : '') + name + (ver ? ' (' + ver + ')' : '') + '.' + (withWarranty ? ' Con Garantía Extendida de 2 años.' : '') + (withNames.length > (withWarranty ? 1 : 0) ? ' Con ' + withNames.filter(function (n) { return n !== 'garantía extendida'; }).join(' y ') + '.' : '') + ' ¿Me ayudan con el pedido?';
      var waHref = 'https://wa.me/526147335856?text=' + encodeURIComponent(msg);
      var qpBox = root.querySelector('[data-at-pdp-qp]');
      var fleetLabel = qpBox && qpBox.getAttribute('data-fleet-label');
      var fleetAlt = qpBox && qpBox.getAttribute('data-fleet-alt');
      each(root.querySelectorAll('[data-at-pdp-wa]'), function (a) {
        var cm = a.getAttribute('data-msg');
        a.href = (cm && !fleet) ? 'https://wa.me/526147335856?text=' + encodeURIComponent(cm) : waHref;
        each(a.querySelectorAll('[data-at-pdp-wa-retail]'), function (x) { x.hidden = fleet; });
        each(a.querySelectorAll('[data-at-pdp-wa-fleet]'), function (x) { x.hidden = !fleet; });
        a.hidden = !!(fleet && fleetLabel);
      });
      if (qpBox) {
        each(qpBox.querySelectorAll('[data-at-qp-note-retail]'), function (x) { x.hidden = fleet && !!qpBox.querySelector('[data-at-qp-note-fleet]'); });
        each(qpBox.querySelectorAll('[data-at-qp-note-fleet]'), function (x) { x.hidden = !fleet; });
      }
      var add = root.querySelector('form[data-at-product-form] [data-at-pdp-main-add]');
      if (add && fleetLabel) {
        var fb = add.parentNode.querySelector('[data-at-pdp-fleet-btn]');
        if (!fb) {
          fb = document.createElement('a');
          fb.className = 'at-btn at-btn--p at-pdp-buy__add at-pdp-buy__fleet';
          fb.setAttribute('data-at-pdp-fleet-btn', '');
          fb.target = '_blank'; fb.rel = 'noopener';
          fb.textContent = fleetLabel;
          add.parentNode.insertBefore(fb, add.nextSibling);
        }
        fb.href = waHref;
        fb.hidden = !fleet;
        add.hidden = fleet;
      }
      if (form && fleetAlt) {
        var alt = form.querySelector('[data-at-pdp-fleet-alt]');
        if (!alt) {
          alt = document.createElement('a');
          alt.className = 'at-btn at-btn--o at-btn--block at-pdp-buy__now';
          alt.setAttribute('data-at-pdp-fleet-alt', '');
          alt.href = qpBox.getAttribute('data-fleet-alt-url');
          alt.textContent = fleetAlt;
          var waBtn = form.querySelector('[data-at-pdp-wa]');
          if (waBtn) waBtn.parentNode.insertBefore(alt, waBtn.nextSibling); else form.appendChild(alt);
        }
        alt.hidden = !fleet;
      }
    }
    window.ATpdpUpdate = update;

    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-at-pdp-qp] [data-at-qp-qty]');
      if (!o) return;
      e.preventDefault();
      var box = o.closest('[data-at-pdp-qp]');
      var root = o.closest('[data-at-product]');
      each(box.querySelectorAll('[data-at-qp-qty]'), function (x) { var on = x === o; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      var input = root && root.querySelector('form[data-at-product-form] input[name="quantity"]');
      if (input) {
        input.value = o.getAttribute('data-at-qp-qty');
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      update(root);
    });
    document.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('form[data-at-product-form] input[name="quantity"]');
      if (!input) return;
      var root = input.closest('[data-at-product]');
      if (!root) return;
      var box = root.querySelector('[data-at-pdp-qp]');
      if (box) {
        var q = parseInt(input.value, 10) || 1;
        var opts = qsa(box, '[data-at-qp-qty]');
        var pick = opts.filter(function (x) { return !x.hasAttribute('data-at-qp-fleet') && parseInt(x.getAttribute('data-at-qp-qty'), 10) === q; })[0];
        if (!pick) pick = opts.filter(function (x) { return x.hasAttribute('data-at-qp-fleet') && q >= parseInt(x.getAttribute('data-at-qp-qty'), 10); })[0];
        if (pick) opts.forEach(function (x) { var on = x === pick; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      }
      setTimeout(function () { update(root); }, 0);
    });

    /* Precio, MSI (redondeado a pesos), línea de envío y avisos al cambiar de variante */
    document.addEventListener('at:variant', function (e) {
      var root = e.target;
      var v = e.detail && e.detail.variant;
      if (!v || !root.querySelectorAll) return;
      var form = formOf(root);
      if (form) form.setAttribute('data-price', v.price);
      each(root.querySelectorAll('[data-at-pdp-ship]'), function (el) {
        el.textContent = pickText(v.price >= 200000 ? el.getAttribute('data-free') : el.getAttribute('data-paid'));
      });
      each(root.querySelectorAll('[data-at-pdp-msi]'), function (el) {
        var on = v.price >= 2000000;
        el.hidden = !on;
        if (on) each(el.querySelectorAll('[data-at-pdp-msi-amount]'), function (amount) { amount.textContent = money(msiOf(v.price)); });
      });
      each(root.querySelectorAll('[data-at-pdp-soldout]'), function (el) { el.hidden = !!v.available; });
      each(root.querySelectorAll('[data-at-pdp-buy-now]'), function (b) { b.disabled = !v.available; });
      setTimeout(function () { update(root); }, 0);
    });

    /* Si la combinación no existe, "Comprar ahora" sigue al botón principal */
    document.addEventListener('change', function (e) {
      var field = e.target.closest && e.target.closest('[data-at-option]');
      if (!field) return;
      var root = field.closest('[data-at-product]');
      if (!root) return;
      setTimeout(function () {
        var add = root.querySelector('[data-at-pdp-main-add]');
        if (!add) return;
        each(root.querySelectorAll('[data-at-pdp-buy-now]'), function (b) { b.disabled = !!add.disabled; });
      }, 0);
    });

    /* Garantía Extendida: la casilla visible se refleja en la casilla espejo del formulario */
    document.addEventListener('change', function (e) {
      var w = e.target.closest && e.target.closest('[data-at-pdp-warranty]');
      if (!w) return;
      var root = w.closest('[data-at-product]') || document;
      each(root.querySelectorAll('[data-at-pdp-proxy="' + w.getAttribute('data-at-pdp-warranty') + '"]'), function (p) { p.checked = w.checked; });
      if (root !== document) update(root);
    });

    /* Comprar ahora: agrega (con personalización y complementos) y va al pago */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-at-pdp-buy-now]');
      if (!b) return;
      e.preventDefault();
      var form = b.closest('form[data-at-product-form]');
      if (!form || !window.AT || !AT.cart) return;
      if (form.reportValidity && !form.reportValidity()) return;
      var fd = new FormData(form);
      var item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
      var props = {};
      fd.forEach(function (val, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && String(val).trim() !== '') props[m[1]] = val;
      });
      if (Object.keys(props).length) item.properties = props;
      var items = [item];
      each(form.querySelectorAll('[data-at-addon-variant]'), function (a) {
        if (a.checked) items.push({ id: parseInt(a.getAttribute('data-at-addon-variant'), 10), quantity: 1 });
      });
      b.classList.add('is-loading');
      AT.cart.add(items, { open: false }).then(function () {
        window.location.href = '/checkout';
      }).catch(function (err) {
        b.classList.remove('is-loading');
        if (AT.toast) AT.toast((err && err.data && err.data.description) || (AT.strings && AT.strings.error) || 'No se pudo agregar.');
      });
    });

    /* Selector de conector: paso conector + paso Bluetooth sobre los radios reales de la opción */
    function radiosOf(box) { return Array.prototype.slice.call(box.querySelectorAll('input[data-cx-type]')); }
    function ok(r) { return !r.parentNode.classList.contains('is-unavailable'); }
    function pick(list) { return list.filter(ok)[0] || list[0] || null; }
    function cxName(box, t) {
      var btn = box.querySelector('[data-at-cx-type="' + t + '"] b') || box.querySelector('input[data-cx-type="' + t + '"] + .at-cx b');
      return btn ? btn.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function cxSync(box) {
      var radios = radiosOf(box);
      var cur = radios.filter(function (r) { return r.checked; })[0] || radios[0];
      if (!cur) return;
      var t = cur.getAttribute('data-cx-type');
      var bt = cur.getAttribute('data-cx-bt');
      each(box.querySelectorAll('[data-at-cx-type]'), function (btn) {
        var ty = btn.getAttribute('data-at-cx-type');
        var on = ty === t;
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var same = radios.filter(function (r) { return r.getAttribute('data-cx-type') === ty && r.getAttribute('data-cx-bt') === bt; })[0];
        btn.classList.toggle('is-unavailable', !!same && !ok(same));
      });
      each(box.querySelectorAll('[data-at-cx-bt]'), function (btn) {
        var b = btn.getAttribute('data-at-cx-bt');
        var on = b === bt;
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.disabled = !radios.some(function (r) { return r.getAttribute('data-cx-type') === t && r.getAttribute('data-cx-bt') === b; });
      });
      each(box.querySelectorAll('[data-at-cx-info]'), function (p) { p.hidden = p.getAttribute('data-at-cx-info') !== t; });
      var label = box.querySelector('[data-at-cx-current]');
      if (label) {
        var name = cur.parentNode.querySelector('b');
        if (name) label.textContent = name.textContent;
      }
      var sum = box.querySelector('[data-at-cx-sum]');
      var sumV = sum && sum.querySelector('[data-at-cx-sum-v]');
      if (sumV) {
        var txt = cxName(box, t);
        if (bt) txt += ' · ' + (bt === 'no' ? sum.getAttribute('data-bt-no') : sum.getAttribute('data-bt-yes'));
        sumV.textContent = txt;
      }
      var root = box.closest('[data-at-product]');
      if (root) update(root);
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-at-cx-type],[data-at-cx-bt]');
      if (!btn || btn.disabled) return;
      var box = btn.closest('[data-at-cx]');
      if (!box) return;
      e.preventDefault();
      var radios = radiosOf(box);
      var cur = radios.filter(function (r) { return r.checked; })[0] || radios[0];
      if (!cur) return;
      var byType = btn.hasAttribute('data-at-cx-type');
      var t = byType ? btn.getAttribute('data-at-cx-type') : cur.getAttribute('data-cx-type');
      var bt = byType ? cur.getAttribute('data-cx-bt') : btn.getAttribute('data-at-cx-bt');
      var match = radios.filter(function (r) { return r.getAttribute('data-cx-type') === t && r.getAttribute('data-cx-bt') === bt; })[0];
      if (!match) {
        match = byType
          ? pick(radios.filter(function (r) { return r.getAttribute('data-cx-type') === t; }))
          : pick(radios.filter(function (r) { return r.getAttribute('data-cx-bt') === bt; }));
      }
      if (match && !match.checked) {
        match.checked = true;
        match.dispatchEvent(new Event('change', { bubbles: true }));
      }
      cxSync(box);
    });
    document.addEventListener('change', function (e) {
      var r = e.target.closest && e.target.closest('[data-at-cx] input[data-cx-type]');
      if (!r) return;
      setTimeout(function () { cxSync(r.closest('[data-at-cx]')); }, 0);
    });

    /* Galería: etiqueta del contador ("1 / 7 · Frente") y miniatura activa a la vista */
    function galleryWatch(g) {
      if (g._atPdpWatch || !('MutationObserver' in window)) return;
      g._atPdpWatch = true;
      var sync = function () {
        var idx = parseInt(g.getAttribute('data-index') || '0', 10) || 0;
        var thumbs = g.querySelectorAll('[data-at-thumb]');
        var th = thumbs[idx];
        var lbl = g.querySelector('[data-at-pdp-gal-label]');
        if (lbl) {
          var slides = g.querySelectorAll('[data-at-slide]');
          var t = (th && th.getAttribute('data-label')) || (slides[idx] && slides[idx].getAttribute('data-label')) || '';
          lbl.textContent = t ? ' · ' + t : '';
        }
        // figuras y tarjetas de la zona debajo de la galería: marcar la que corresponde a la foto a la vista
        var gRoot = g.closest('[data-at-product]');
        var slideOn = g.querySelectorAll('[data-at-slide]')[idx];
        var mediaOn = slideOn ? slideOn.getAttribute('data-media-id') : '';
        if (gRoot) each(gRoot.querySelectorAll('[data-at-pdp-goto]'), function (t) { t.classList.toggle('is-on', !!mediaOn && t.getAttribute('data-at-pdp-goto') === mediaOn); });
        var strip = th && th.parentNode;
        if (strip && strip.scrollWidth > strip.clientWidth + 2) {
          var left = th.offsetLeft - (strip.clientWidth - th.offsetWidth) / 2;
          strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        } else if (strip && strip.scrollHeight > strip.clientHeight + 2) {
          var top = th.offsetTop - (strip.clientHeight - th.offsetHeight) / 2;
          strip.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }
      };
      new MutationObserver(sync).observe(g, { attributes: true, attributeFilter: ['data-index'] });
    }

    /* Zona debajo de la galería: una figura o tarjeta con foto abre esa foto en la galería */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-at-pdp-goto]');
      if (!b) return;
      var root = b.closest('[data-at-product]');
      var g = root && root.querySelector('[data-at-gallery]');
      if (!g || !window.AT || !AT.galleryToMedia) return;
      e.preventDefault();
      AT.galleryToMedia(g, b.getAttribute('data-at-pdp-goto'));
      var r = g.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) {
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        g.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    });

    function init(ctx) {
      each((ctx || document).querySelectorAll('[data-at-product]'), function (root) {
        each(root.querySelectorAll('.at-pdp-gal[data-at-gallery]'), galleryWatch);
        each(root.querySelectorAll('[data-at-cx]'), function (box) { if (box.querySelector('[data-at-cx-sum]')) cxSync(box); });
        update(root);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["at-product-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.ATpnav) return;
    window.ATpnav = true;
    function each(list, fn) { Array.prototype.forEach.call(list, fn); }
    function setup() {
      each(document.querySelectorAll('[data-at-pnav]'), function (nav) {
        var tabs = Array.prototype.slice.call(nav.querySelectorAll('[data-at-pnav-tab]'));
        var targets = [];
        tabs.forEach(function (a) {
          var id = decodeURIComponent((a.getAttribute('href') || '').slice(1));
          var el = id && document.getElementById(id);
          a.hidden = !el;
          if (el) targets.push({ a: a, el: el });
        });
        var firstVisible = tabs.filter(function (a) { return !a.hidden; })[0];
        tabs.forEach(function (a) { a.classList.toggle('is-on', a === firstVisible); });
        if (nav._atSpy || !('IntersectionObserver' in window) || !targets.length) return;
        nav._atSpy = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            targets.forEach(function (t) { t.a.classList.toggle('is-on', t.el === en.target); });
          });
        }, { rootMargin: '-35% 0px -60% 0px' });
        targets.forEach(function (t) { nav._atSpy.observe(t.el); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
    document.addEventListener('shopify:section:load', setup);

    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-at-pnav-add]');
      if (!b) return;
      e.preventDefault();
      var form = document.querySelector('[data-at-product] form[data-at-product-form]');
      if (form && form.requestSubmit) { form.requestSubmit(); return; }
      var root = document.querySelector('[data-at-product]');
      if (root) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    document.addEventListener('at:variant', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      each(document.querySelectorAll('[data-at-pnav-price]'), function (el) {
        el.textContent = window.AT && AT.formatMoney ? AT.formatMoney(v.price) : el.textContent;
      });
      each(document.querySelectorAll('[data-at-pnav-add]'), function (b) {
        b.disabled = !v.available;
        b.textContent = v.available ? 'Agregar al carrito' : 'Agotado';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["at-product-related"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.ATprel) return;
    window.ATprel = true;
    function load(sec) {
      if (sec._atReco) return;
      sec._atReco = true;
      fetch(sec.getAttribute('data-at-reco-url'), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var append = sec.hasAttribute('data-at-reco-append');
          var got = false;
          Array.prototype.forEach.call(sec.querySelectorAll('[data-at-reco-items]'), function (target) {
            var fresh = doc.querySelector('[data-at-reco-items="' + target.getAttribute('data-at-reco-items') + '"]');
            if (!fresh || !fresh.children.length) return;
            got = true;
            if (append) { while (fresh.firstElementChild) target.appendChild(fresh.firstElementChild); }
            else target.innerHTML = fresh.innerHTML;
          });
          if (got) sec.hidden = false;
        })
        .catch(function () {});
    }
    function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-at-reco-url]'), load); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["at-product-sticky"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.ATpsticky) return;
    window.ATpsticky = true;
    document.addEventListener('at:variant', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      Array.prototype.forEach.call(document.querySelectorAll('[data-at-psticky]'), function (bar) {
        var price = bar.querySelector('[data-at-psticky-price]');
        if (price && window.AT && AT.formatMoney) price.textContent = AT.formatMoney(v.price);
        var id = bar.querySelector('[data-at-psticky-id]');
        if (id) id.value = v.id;
        var btn = bar.querySelector('[data-at-psticky-add]');
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Agregar al carrito' : 'Agotado'; }
      });
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-at-psticky-add]');
      if (!btn) return;
      var main = document.querySelector('[data-at-product] form[data-at-product-form]');
      if (main && main.requestSubmit && !btn.closest('[data-at-product]')) {
        e.preventDefault();
        main.requestSubmit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
